import { ROUTER_COMMAND_PREFIX } from '@/services/router-proxy/constants';
import { type Manifest, type RouterConfig, PAGE_TYPE } from '@/types/manifest.ts';

const routerConfig: RouterConfig = {
    type: PAGE_TYPE.PAGE,
    name: 'tasks',
    exclusiveRoutePath: '/tasks',
    getComponent: () => import('./HistoryTasks.vue'),
};

export const manifest: Manifest = {
    ...routerConfig,
};

/**
 * 去到任务列表页面
 */
const COMMAND_ID = `${ROUTER_COMMAND_PREFIX}tasks`;

declare module '@patsnap/tahiti-core' {
    export interface CommandService {
        /**
         * 去到任务列表页面
         */
        executeCommand(commandId: typeof COMMAND_ID): void;
    }
}
